<template>
  <div
    class="examInfo">
    <div class="exam-header">
      <div class="name">
        {{ exam.name }}
      </div>
      <slot name="actions"></slot>
    </div>
    <div class="time" v-if="vertical">
      <div class="row">
        {{ $t('exam.START') }} {{ date2local(exam.start) }}
      </div>
      <div class="row">
        {{ $t('exam.END') }} {{ date2local(exam.end) }}
      </div>
      <div class="row">
        {{ $t('exam.TIMING') }} {{ exam.timing }} {{ $t('exam.TIME_UNIT') }}
      </div>
    </div>
    <div v-else class="time">
      {{ date2local(exam.start) }}
      —
      {{ date2local(exam.end) }}
    </div>
  </div>
</template>

<script>
import { date2local } from '@/utils/utils.format'

export default {
  name: 'ExamInfo',
  props: {
    vertical: Boolean,
    exam: Object
  },
  methods: {
    date2local
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

.examInfo {
  color: $text-main;
  line-height: 24px;

  .exam-header {
    display: flex;
    justify-content: space-between;
  }

  .name {
    font-size: 21px;
    margin-bottom: 8px;
    max-width: 532px;
  }

  .time {
    color: $text-secondary;
  }
}

.exam-actions {
  position: relative;
  opacity: 0;
  transition: opacity 0.15s linear;
}

.exam:hover .exam-actions {
  display: flex;
  opacity: 1;
}

.exam:hover .edit-action {
  @extend %action-icon;
  margin-left: 10px;
  background-image: url("~@/assets/edit.svg");
  width: 26px;
  height: 26px;
}

.exam:hover .delete-action {
  @extend %action-icon;
  margin-left: 6px;
  background-image: url("~@/assets/x.svg");
  width: 30px;
  height: 30px;
}

.exam:hover .save-action {
  @extend %action-icon;
  margin-left: 11px;
  background-image: url("~@/assets/save.svg");
  width: 27px;
  height: 27px;
}

</style>
